var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14.6154C4 8.75267 8.75267 4 14.6154 4H85.3846C91.2476 4 96 8.75272 96 14.6154V50C96 51.9542 94.4157 53.5385 92.4615 53.5385C90.5074 53.5385 88.9231 51.9542 88.9231 50V14.6154C88.9231 12.6611 87.3388 11.0769 85.3846 11.0769H14.6154C12.6612 11.0769 11.0769 12.6612 11.0769 14.6154V85.3846C11.0769 87.3388 12.6611 88.9231 14.6154 88.9231H50C51.9542 88.9231 53.5385 90.5074 53.5385 92.4615C53.5385 94.4157 51.9542 96 50 96H14.6154C8.75272 96 4 91.2476 4 85.3846V14.6154Z",
    fill: "#2C5DFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.872 58.2564C63.0095 58.2564 58.2566 63.0093 58.2566 68.8718C58.2566 74.7343 63.0095 79.4872 68.872 79.4872C74.7345 79.4872 79.4874 74.7343 79.4874 68.8718C79.4874 63.0093 74.7345 58.2564 68.872 58.2564ZM51.1797 68.8718C51.1797 59.1005 59.1007 51.1795 68.872 51.1795C78.6433 51.1795 86.5643 59.1005 86.5643 68.8718C86.5643 78.6432 78.6433 86.5641 68.872 86.5641C59.1007 86.5641 51.1797 78.6432 51.1797 68.8718Z",
    fill: "#2C5DFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.904 76.0973C79.1245 74.5711 81.3514 74.3239 82.8772 75.5444L94.6721 84.9803C96.1983 86.2013 96.4455 88.4282 95.225 89.954C94.004 91.4802 91.7776 91.7274 90.2514 90.5064L78.4565 81.0705C76.9307 79.85 76.683 77.6231 77.904 76.0973Z",
    fill: "#2C5DFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8721 31.1282C22.8721 29.174 24.4563 27.5897 26.4105 27.5897H73.59C75.5442 27.5897 77.1285 29.174 77.1285 31.1282C77.1285 33.0824 75.5442 34.6666 73.59 34.6666H26.4105C24.4563 34.6666 22.8721 33.0824 22.8721 31.1282Z",
    fill: "#2C5DFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8721 50C22.8721 48.0458 24.4563 46.4615 26.4105 46.4615H45.2823C47.2365 46.4615 48.8208 48.0458 48.8208 50C48.8208 51.9542 47.2365 53.5385 45.2823 53.5385H26.4105C24.4563 53.5385 22.8721 51.9542 22.8721 50Z",
    fill: "#2C5DFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/Detail.a5bea12bed4387f1b607026723c8b7da.svg";
export { ForwardRef as ReactComponent };